/** Main theme + config/settings_data.json — used to detect app embed / app block activation */

export const THEMES_QUERY = {

  query: `query GetStoreThemes {

    themes(first: 10, roles: MAIN) {

      edges {

        node {

          id

          name

          role

          files(filenames: ["config/settings_data.json"]) {

            edges {

              node {

                body {

                  ... on OnlineStoreThemeFileBodyText {

                    content

                  }

                }

              }

            }

          }

        }

      }

    }

  }`,

};

/**
 * Manual refresh: unique comment forces a new Admin GraphQL document so the request
 * is not served from a stale in-memory cache.
 */
export function getThemesQuery(forceRefresh = false) {
  if (!forceRefresh) {
    return THEMES_QUERY;
  }
  const q = THEMES_QUERY.query.replace(
    /query\s+GetStoreThemes\s*\{/,
    `query GetStoreThemes { #ref-${Date.now()}`,
  );
  return { query: q };
}

